import { Patient, PatientUpdateIdentityDocumentCommand } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../../translations';
import { createIdentityDocumentTypeVisitor, getIdentityDocumentType } from '../../selector/IdentityDocumentTypeField';

import {
   PassportIdentityDocumentEditFormBean,
   PassportIdentityDocumentEditFormController,
} from './PassportIdentityDocumentEditForm';

type PassportIdentityDocumentEditModalConfirmButtonProps = Pick<
   PassportIdentityDocumentEditFormController,
   'handleSubmit'
> & {
   readonly patientId: number;
   readonly onIdentityDocumentUpdated: (patient: Patient) => Promise<void> | void;
   readonly onSuccess: VoidFunction;
};

export const PassportIdentityDocumentEditModalConfirmButton = (
   props: PassportIdentityDocumentEditModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: updatePatientIdentityDocument } = useCqrsCommand<
      Patient,
      PassportIdentityDocumentEditFormBean
   >(
      (parameters) => {
         const command = new PatientUpdateIdentityDocumentCommand();
         const identityDocumentTypeVisitor = createIdentityDocumentTypeVisitor(parameters.identityDocumentType);
         command.id = props.patientId;
         command.identityDocument = IdentityDocument.of(
            getIdentityDocumentType(identityDocumentTypeVisitor),
            parameters.identityDocumentValue!,
            parameters.passportCountry!,
            parameters.passportValidTo!
         );
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               identityDocumentTranslationKeys.passport.enter.modal.saveAction.identityDocumentUpdated
            );
         },
      }
   );

   const handleClick = props.handleSubmit(async (data) => {
      const patient = await updatePatientIdentityDocument(data);
      try {
         await props.onIdentityDocumentUpdated(patient);
      } finally {
         props.onSuccess();
      }
   });

   return (
      <ModalConfirmButton
         label={identityDocumentTranslationKeys.passport.edit.modal.saveAction.label}
         onClick={handleClick}
      />
   );
};
